/**
 * VALTIVA — Product Add-On Selector + Add-to-Cart Confirmation
 *
 * PHASE 2b (duplicate bed prevention):
 * - Before adding to cart, checks whether the SAME bed (same product +
 *   same size variant) is already sitting in the cart.
 * - If found: shows a small decision modal ("Update My Configuration" as
 *   the primary action, "Add As A New Item" as the secondary one) rather
 *   than silently duplicating add-ons or silently overwriting a genuinely
 *   different second bed the customer may want.
 * - "Update": removes the existing bed's entire bundle (the bed line item
 *   plus every add-on sharing its _bundle_id), then adds the newly
 *   configured version fresh - so previously selected add-ons are never
 *   duplicated and only the current, real selection is reflected.
 * - "Add As New": skips removal, proceeds exactly as before - covers the
 *   genuine case of ordering two differently configured beds of the same
 *   model/size.
 */

/* ---------------- Swatch zoom/preview (hover on desktop, tap on mobile) ---------------- */
(function () {
  if (document.getElementById('valtiva-swatch-preview-styles')) return;

  var style = document.createElement('style');
  style.id = 'valtiva-swatch-preview-styles';
  style.textContent =
    '.product-addons__swatch-preview{position:fixed;z-index:9999;pointer-events:none;opacity:0;transform:translateY(6px) scale(0.96);transition:opacity 0.18s ease,transform 0.18s ease;background:#fff;border-radius:10px;box-shadow:0 12px 32px rgba(15,15,15,0.18),0 2px 8px rgba(15,15,15,0.08);padding:10px;display:flex;flex-direction:column;align-items:center;width:148px;}' +
    '.product-addons__swatch-preview.is-visible{opacity:1;transform:translateY(0) scale(1);}' +
    '.product-addons__swatch-preview img{width:128px;height:128px;object-fit:cover;border-radius:6px;display:block;}' +
    '.product-addons__swatch-preview__swatch-fallback{width:128px;height:128px;border-radius:6px;}' +
    '.product-addons__swatch-preview__label{margin-top:8px;font-size:12px;letter-spacing:0.04em;text-transform:uppercase;color:#1a1a1a;font-weight:600;text-align:center;}' +
    '.product-addons__swatch{position:relative;transition:transform 0.15s ease,box-shadow 0.15s ease;}' +
    '.product-addons__swatch:hover,.product-addons__swatch:focus-visible{transform:translateY(-2px);box-shadow:0 6px 16px rgba(15,15,15,0.14);}' +
    '.product-addons__options--invalid{outline:1px solid #E0A03A;outline-offset:6px;border-radius:8px;}' +
    '.product-addons__inline-error{color:#C77A2E;font-size:12.5px;margin:6px 0 0 0;font-weight:500;}' +
    '[data-add-to-cart].is-disabled-incomplete{opacity:0.45;cursor:not-allowed;pointer-events:none;}' +
    '@media (max-width:749px){.product-addons__swatch-preview{width:128px;}.product-addons__swatch-preview img,.product-addons__swatch-preview__swatch-fallback{width:108px;height:108px;}}';
  document.head.appendChild(style);

  var preview = document.createElement('div');
  preview.className = 'product-addons__swatch-preview';
  preview.setAttribute('aria-hidden', 'true');
  document.body.appendChild(preview);

  var hideTimer = null;

  function showPreview(swatchBtn) {
    clearTimeout(hideTimer);
    var label = swatchBtn.getAttribute('data-choice-label') || swatchBtn.title || '';
    var img = swatchBtn.querySelector('img');

    preview.innerHTML = '';
    if (img && img.src) {
      var previewImg = document.createElement('img');
      previewImg.src = img.src;
      previewImg.alt = label;
      preview.appendChild(previewImg);
    } else {
      var fallback = document.createElement('div');
      fallback.className = 'product-addons__swatch-preview__swatch-fallback';
      fallback.style.backgroundColor = swatchBtn.style.backgroundColor || '#d9d4cc';
      preview.appendChild(fallback);
    }

    var labelEl = document.createElement('span');
    labelEl.className = 'product-addons__swatch-preview__label';
    labelEl.textContent = label;
    preview.appendChild(labelEl);

    positionPreview(swatchBtn);
    preview.classList.add('is-visible');
  }

  function positionPreview(swatchBtn) {
    var rect = swatchBtn.getBoundingClientRect();
    var previewWidth = 148;
    var previewHeight = preview.offsetHeight || 190;
    var left = rect.left + rect.width / 2 - previewWidth / 2;
    var top = rect.top - previewHeight - 12;

    if (top < 8) {
      top = rect.bottom + 12;
    }
    left = Math.max(8, Math.min(left, window.innerWidth - previewWidth - 8));

    preview.style.left = left + 'px';
    preview.style.top = top + 'px';
  }

  function hidePreview() {
    preview.classList.remove('is-visible');
  }

  document.addEventListener('mouseenter', function (event) {
    var swatch = event.target.closest && event.target.closest('.product-addons__swatch');
    if (swatch) showPreview(swatch);
  }, true);

  document.addEventListener('mouseleave', function (event) {
    var swatch = event.target.closest && event.target.closest('.product-addons__swatch');
    if (swatch) hidePreview();
  }, true);

  document.addEventListener('focusin', function (event) {
    var swatch = event.target.closest && event.target.closest('.product-addons__swatch');
    if (swatch) showPreview(swatch);
  });

  document.addEventListener('focusout', function (event) {
    var swatch = event.target.closest && event.target.closest('.product-addons__swatch');
    if (swatch) hidePreview();
  });

  document.addEventListener('touchstart', function (event) {
    var swatch = event.target.closest && event.target.closest('.product-addons__swatch');
    if (!swatch) return;
    showPreview(swatch);
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hidePreview, 1600);
  }, { passive: true });

  window.addEventListener('scroll', function () {
    if (!preview.classList.contains('is-visible')) return;
    hidePreview();
  }, true);
})();

/* ---------------- Confirmation panel open/close (global, every page) ---------------- */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var panel = document.getElementById('ValtivaConfirmPanel');
    if (!panel) return;

    panel.querySelectorAll('[data-valtiva-confirm-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  });

  window.valtivaShowConfirmPanel = function (cartResponse) {
    var panel = document.getElementById('ValtivaConfirmPanel');
    if (!panel || !cartResponse || !cartResponse.items || cartResponse.items.length === 0) return;

    var mainItem = cartResponse.items[0];
    var addonItems = cartResponse.items.slice(1);

    var productEl = panel.querySelector('[data-valtiva-confirm-product]');
    if (!productEl) return;

    var imgHtml = '';
    if (mainItem.image) {
      imgHtml = '<div class="valtiva-confirm__product-image"><img src="' + mainItem.image + '" alt=""></div>';
    }

    var configHtml = '';
    if (mainItem.variant_title && mainItem.variant_title !== 'Default Title') {
      configHtml += '<span>Size: <strong>' + mainItem.variant_title + '</strong></span>';
    }
    if (mainItem.properties) {
      for (var k in mainItem.properties) {
        if (Object.prototype.hasOwnProperty.call(mainItem.properties, k) && k.charAt(0) !== '_' && mainItem.properties[k]) {
          configHtml += '<span>' + k + ': <strong>' + mainItem.properties[k] + '</strong></span>';
        }
      }
    }
    addonItems.forEach(function (addon) {
      var label = null;
      var value = null;
      if (addon.properties) {
        for (var k2 in addon.properties) {
          if (Object.prototype.hasOwnProperty.call(addon.properties, k2) && k2.charAt(0) !== '_' && addon.properties[k2]) {
            label = k2;
            value = addon.properties[k2];
            break;
          }
        }
      }
      if (label) {
        configHtml += '<span>' + label + ': <strong>' + value + '</strong></span>';
      }
    });

    productEl.innerHTML =
      imgHtml +
      '<div><div class="valtiva-confirm__product-title">' + mainItem.product_title + '</div>' +
      '<div class="valtiva-confirm__product-config">' + configHtml + '</div></div>';

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
  };
})();

/* ---------------- Duplicate bed detection + decision modal ---------------- */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('ValtivaDuplicateModal');
    if (!modal) return;

    modal.querySelectorAll('[data-valtiva-dupe-cancel]').forEach(function (el) {
      el.addEventListener('click', function () {
        window.valtivaCloseDuplicateModal();
      });
    });
  });

  window.valtivaCloseDuplicateModal = function () {
    var modal = document.getElementById('ValtivaDuplicateModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  };

  /* Shows the modal and resolves a promise once the customer picks an
     option - lets the calling code simply "await" the customer's choice
     rather than juggling separate button-click callbacks. */
  window.valtivaShowDuplicateModal = function () {
    return new Promise(function (resolve) {
      var modal = document.getElementById('ValtivaDuplicateModal');
      if (!modal) {
        resolve('new');
        return;
      }

      var updateBtn = modal.querySelector('[data-valtiva-dupe-update]');
      var newBtn = modal.querySelector('[data-valtiva-dupe-new]');
      var cancelEls = modal.querySelectorAll('[data-valtiva-dupe-cancel]');

      function cleanup(choice) {
        updateBtn.removeEventListener('click', onUpdate);
        newBtn.removeEventListener('click', onNew);
        cancelEls.forEach(function (el) {
          el.removeEventListener('click', onCancel);
        });
        window.valtivaCloseDuplicateModal();
        resolve(choice);
      }

      function onUpdate() {
        cleanup('update');
      }
      function onNew() {
        cleanup('new');
      }
      function onCancel() {
        cleanup('cancel');
      }

      updateBtn.addEventListener('click', onUpdate);
      newBtn.addEventListener('click', onNew);
      cancelEls.forEach(function (el) {
        el.addEventListener('click', onCancel);
      });

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    });
  };

  /* Finds an existing cart line item for the same variant (same product,
     same size) that isn't itself a bundled add-on - i.e. a genuine
     "this exact bed is already in the cart" match. Returns the item, or
     null if none found. */
  window.valtivaFindExistingBed = function (variantId) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var match = null;
        cart.items.forEach(function (item) {
          if (match) return;
          var isAddon = item.properties && item.properties._bundle_addon === 'true';
          if (!isAddon && String(item.variant_id) === String(variantId)) {
            match = item;
          }
        });
        return match;
      })
      .catch(function () {
        return null;
      });
  };

  /* Removes an existing bed's entire bundle - the bed itself plus every
     add-on sharing its _bundle_id - so a genuine "Update My Configuration"
     never leaves old add-ons behind. If the existing bed has no bundle id
     (a simple product with no add-ons), just removes that one line item. */
  window.valtivaRemoveExistingBundle = function (existingItem) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var bundleId = existingItem.properties && existingItem.properties._bundle_id;
        var updates = {};
        updates[existingItem.key] = 0;

        if (bundleId) {
          cart.items.forEach(function (item) {
            if (item.properties && item.properties._bundle_id === bundleId) {
              updates[item.key] = 0;
            }
          });
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      });
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  var addonGroups = document.querySelectorAll('[data-addon-group]');

  var mainForm = document.querySelector('.product-single__form');
  var mainButton = document.querySelector('[data-add-to-cart]');
  if (!mainForm || !mainButton) return;

  var errorEl = document.createElement('p');
  errorEl.className = 'product-addons__error';
  errorEl.setAttribute('data-addons-error', '');
  errorEl.setAttribute('role', 'alert');
  errorEl.hidden = true;
  mainButton.parentNode.insertBefore(errorEl, mainButton);

  var variantPrices = {};
  var variantDataEl = document.querySelector('[data-product-addons-variants]');
  if (variantDataEl) {
    try {
      variantPrices = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      variantPrices = {};
    }
  }

  function formatMoney(cents) {
    return '\u00A3' + (cents / 100).toFixed(2);
  }

  var totalsEl = null;
  if (addonGroups.length > 0) {
    totalsEl = document.createElement('div');
    totalsEl.className = 'product-addons-total';
    totalsEl.innerHTML =
      '<div class="product-addons-total__row"><span>Product total</span><span data-addons-product-total>&mdash;</span></div>' +
      '<div class="product-addons-total__row"><span>Options total</span><span data-addons-options-total>&mdash;</span></div>' +
      '<div class="product-addons-total__row product-addons-total__row--grand"><span>Grand total</span><span data-addons-grand-total>&mdash;</span></div>';
    mainButton.parentNode.insertBefore(totalsEl, mainButton);
  }

  function renderTotals() {
    if (!totalsEl) return;
    var idInput = mainForm.querySelector('[name="id"]');
    var currentVariantId = idInput ? idInput.value : null;
    var productPrice = currentVariantId && variantPrices[currentVariantId] !== undefined ? variantPrices[currentVariantId] : 0;

    var optionsTotal = 0;
    addonGroups.forEach(function (group) {
      if (group.getAttribute('data-addon-type') !== 'priced') return;
      var selected = group.querySelector('[data-addon-option].is-selected');
      if (selected) {
        optionsTotal += parseInt(selected.getAttribute('data-variant-price'), 10) || 0;
      }
    });

    var productTotalEl = totalsEl.querySelector('[data-addons-product-total]');
    var optionsTotalEl = totalsEl.querySelector('[data-addons-options-total]');
    var grandTotalEl = totalsEl.querySelector('[data-addons-grand-total]');
    if (productTotalEl) productTotalEl.textContent = formatMoney(productPrice);
    if (optionsTotalEl) optionsTotalEl.textContent = formatMoney(optionsTotal);
    if (grandTotalEl) grandTotalEl.textContent = formatMoney(productPrice + optionsTotal);
  }

  mainForm.addEventListener('change', function () {
    renderTotals();
    updateButtonState();
  });

  function evaluateConditionalBlocks() {
    document.querySelectorAll('[data-conditional-property]').forEach(function (block) {
      var propName = block.getAttribute('data-conditional-property');
      var triggerValue = block.getAttribute('data-conditional-value');
      var triggerGroup = document.querySelector('[data-addon-group][data-property-name="' + propName + '"]');
      if (!triggerGroup) {
        block.hidden = true;
        return;
      }

      var selected = triggerGroup.querySelector('[data-addon-option].is-selected');
      var selectedValue = selected ? selected.getAttribute('data-property-value') : null;

      var shouldShow;
      if (triggerValue === '*') {
        var firstBtn = triggerGroup.querySelector('[data-addon-option]');
        var firstValue = firstBtn ? firstBtn.getAttribute('data-property-value') : null;
        shouldShow = selectedValue !== null && selectedValue !== firstValue;
      } else {
        shouldShow = selectedValue === triggerValue;
      }

      var wasHidden = block.hidden;
      block.hidden = !shouldShow;

      if (!wasHidden && block.hidden) {
        var innerGroup = block.querySelector('[data-addon-group]');
        if (innerGroup) {
          var innerType = innerGroup.getAttribute('data-addon-type');
          var innerButtons = innerGroup.querySelectorAll('[data-addon-option]');

          innerButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });

          if (innerType === 'priced') {
            var noneBtn = innerGroup.querySelector('[data-variant-id=""]');
            if (noneBtn) {
              noneBtn.classList.add('is-selected');
              noneBtn.setAttribute('aria-pressed', 'true');
            }
          } else if (innerType === 'property' && innerButtons.length > 0) {
            innerButtons[0].classList.add('is-selected');
            innerButtons[0].setAttribute('aria-pressed', 'true');
          }
        }

        var innerDateField = block.querySelector('[data-addon-date-field]');
        if (innerDateField) {
          innerDateField.hidden = true;
          var innerDateInput = innerDateField.querySelector('[data-addon-date-input]');
          if (innerDateInput) innerDateInput.value = '';
        }
      }
    });
  }

  var fabricColourMap = {};
  var fabricColourMapEl = document.querySelector('[data-fabric-colour-map]');
  if (fabricColourMapEl) {
    try {
      fabricColourMap = JSON.parse(fabricColourMapEl.textContent);
    } catch (e) {
      fabricColourMap = {};
    }
  }

  var fabricColourGroup = document.querySelector('[data-fabric-colour-group]');
  var fabricGroup = document.querySelector('[data-addon-group][data-property-name="Fabric"]');

  function renderFabricColours(fabricName) {
    if (!fabricColourGroup) return;
    var colours = fabricColourMap[fabricName] || [];
    fabricColourGroup.innerHTML = '';

    if (colours.length === 0) {
      var placeholder = document.createElement('p');
      placeholder.className = 'product-addons__swatch-placeholder';
      placeholder.setAttribute('data-fabric-colour-placeholder', '');
      placeholder.textContent = 'Please select a fabric above to see available colours.';
      fabricColourGroup.appendChild(placeholder);
      evaluateConditionalBlocks();
      renderTotals();
      updateButtonState();
      return;
    }

    colours.forEach(function (colour, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-addons__swatch';
      btn.setAttribute('data-addon-option', '');
      btn.setAttribute('data-variant-id', colour.variantId);
      btn.setAttribute('data-variant-price', colour.price);
      btn.setAttribute('data-choice-label', colour.label);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', colour.label + (colour.price > 0 ? ', +' + formatMoney(colour.price) : ''));
      btn.title = colour.label;

      if (colour.image) {
        var img = document.createElement('img');
        img.src = colour.image;
        img.alt = colour.label;
        img.loading = 'lazy';
        img.className = 'product-addons__swatch-image';
        btn.appendChild(img);
      } else {
        btn.style.backgroundColor = '#d9d4cc';
      }

      var check = document.createElement('span');
      check.className = 'product-addons__swatch-check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.appendChild(check);

      btn.addEventListener('click', function () {
        fabricColourGroup.querySelectorAll('[data-addon-option]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        errorEl.hidden = true;
        evaluateConditionalBlocks();
        renderTotals();
        updateButtonState();
      });

      fabricColourGroup.appendChild(btn);
    });

    evaluateConditionalBlocks();
    renderTotals();
    updateButtonState();
  }

  if (fabricGroup && fabricColourGroup) {
    fabricGroup.querySelectorAll('[data-addon-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        renderFabricColours(btn.getAttribute('data-property-value'));
      });
    });

    var initiallySelected = fabricGroup.querySelector('[data-addon-option].is-selected');
    if (initiallySelected) {
      renderFabricColours(initiallySelected.getAttribute('data-property-value'));
    }
  }

  addonGroups.forEach(function (group) {
    var dateField = group.parentNode.querySelector('[data-addon-date-field]');

    function syncDateField() {
      if (!dateField) return;
      var selected = group.querySelector('[data-addon-option].is-selected');
      var selectedLabel = selected ? selected.getAttribute('data-choice-label') : null;
      var triggerValue = dateField.getAttribute('data-trigger-value');
      dateField.hidden = selectedLabel !== triggerValue;
    }

    group.querySelectorAll('[data-addon-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-addon-option]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        errorEl.hidden = true;
        syncDateField();
        evaluateConditionalBlocks();
        renderTotals();
        updateButtonState();
      });
    });

    syncDateField();
  });

  document.querySelectorAll('[data-addon-date-input]').forEach(function (input) {
    input.addEventListener('input', function () {
      errorEl.hidden = true;
      updateButtonState();
    });
  });

  function getMissingRequiredGroups() {
    var missing = [];
    addonGroups.forEach(function (group) {
      if (group.closest('[hidden]')) return;
      if (group.getAttribute('data-addon-required') !== 'true') return;

      var selected = group.querySelector('[data-addon-option].is-selected');

      if (group.getAttribute('data-addon-type') === 'priced') {
        if (!selected) missing.push(group);
        return;
      }

      if (group.getAttribute('data-addon-type') === 'property') {
        var firstBtn = group.querySelector('[data-addon-option]');
        var firstValue = firstBtn ? firstBtn.getAttribute('data-property-value') : null;
        var selectedValue = selected ? selected.getAttribute('data-property-value') : null;
        if (selectedValue === firstValue) missing.push(group);
      }
    });
    return missing;
  }

  function isBedSizeMissing() {
    var idInput = mainForm.querySelector('[name="id"]');
    return !idInput || !idInput.value;
  }

  function humanizeFieldName(group) {
    var propName = group.getAttribute('data-property-name');
    return propName || 'this option';
  }

  function updateButtonState() {
    document.querySelectorAll('[data-addon-inline-error]').forEach(function (el) {
      el.remove();
    });
    addonGroups.forEach(function (g) {
      g.classList.remove('product-addons__options--invalid');
    });

    var missing = getMissingRequiredGroups();
    var bedSizeMissing = isBedSizeMissing();

    var dynamicCheckoutEls = document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]');

    if (missing.length > 0 || bedSizeMissing) {
      mainButton.classList.add('is-disabled-incomplete');
      mainButton.setAttribute('aria-disabled', 'true');
      dynamicCheckoutEls.forEach(function (el) {
        el.style.display = 'none';
      });

      missing.forEach(function (group) {
        group.classList.add('product-addons__options--invalid');
        var msg = document.createElement('p');
        msg.className = 'product-addons__inline-error';
        msg.setAttribute('data-addon-inline-error', '');
        msg.textContent = 'Please select your ' + humanizeFieldName(group) + '.';
        group.parentNode.insertBefore(msg, group.nextSibling);
      });

      if (bedSizeMissing) {
        var variantPicker = document.querySelector('[data-variant-select], .variant-wrapper, .swatch');
        if (variantPicker && !document.querySelector('[data-bedsize-inline-error]')) {
          var sizeMsg = document.createElement('p');
          sizeMsg.className = 'product-addons__inline-error';
          sizeMsg.setAttribute('data-bedsize-inline-error', '');
          sizeMsg.textContent = 'Please select your Bed Size.';
          variantPicker.parentNode.insertBefore(sizeMsg, variantPicker.nextSibling);
        }
      }
    } else {
      mainButton.classList.remove('is-disabled-incomplete');
      mainButton.removeAttribute('aria-disabled');
      dynamicCheckoutEls.forEach(function (el) {
        el.style.display = '';
      });
      var existingSizeMsg = document.querySelector('[data-bedsize-inline-error]');
      if (existingSizeMsg) existingSizeMsg.remove();
      errorEl.hidden = true;
    }
  }

  evaluateConditionalBlocks();
  renderTotals();
  updateButtonState();

  var dynamicCheckoutObserver = new MutationObserver(function () {
    updateButtonState();
  });
  var dynamicCheckoutParent = mainForm || document.body;
  dynamicCheckoutObserver.observe(dynamicCheckoutParent, { childList: true, subtree: true });

  function getSelections() {
    var addonVariantIds = [];
    var properties = {};
    var missingRequired = [];
    var missingDateField = null;

    addonGroups.forEach(function (group) {
      if (group.closest('[hidden]')) return;

      var selected = group.querySelector('[data-addon-option].is-selected');

      if (group.getAttribute('data-addon-type') === 'priced') {
        if (!selected && group.getAttribute('data-addon-required') === 'true') {
          missingRequired.push(group);
          return;
        }
        if (selected) {
          var variantId = selected.getAttribute('data-variant-id');
          if (variantId) addonVariantIds.push(variantId);
        }
      }

      if (group.getAttribute('data-addon-type') === 'property') {
        var isRequired = group.getAttribute('data-addon-required') === 'true';
        var firstBtn = group.querySelector('[data-addon-option]');
        var firstValue = firstBtn ? firstBtn.getAttribute('data-property-value') : null;
        var selectedValue = selected ? selected.getAttribute('data-property-value') : null;

        if (isRequired && selectedValue === firstValue) {
          missingRequired.push(group);
          return;
        }

        if (selected) {
          var propName = group.getAttribute('data-property-name');
          properties[propName] = selectedValue;
        }
      }
    });

    document.querySelectorAll('[data-addon-date-field]:not([hidden])').forEach(function (field) {
      if (missingDateField) return;
      var input = field.querySelector('[data-addon-date-input]');
      if (input && !input.value) {
        missingDateField = field;
      }
    });

    return { addonVariantIds: addonVariantIds, properties: properties, missingRequired: missingRequired, missingDateField: missingDateField };
  }

  /* Actually performs the add-to-cart request and shows the confirmation
     panel - extracted so both the "no duplicate found" path and the
     "customer chose Update or Add As New" paths can call the same code. */
  function performAddToCart(selections, mainVariantId, quantity) {
    var items = [
      {
        id: mainVariantId,
        quantity: quantity,
        properties: Object.keys(selections.properties).length > 0 ? selections.properties : undefined
      }
    ];

    selections.addonVariantIds.forEach(function (variantId) {
      items.push({ id: variantId, quantity: quantity });
    });

    var originalText = mainButton.textContent;
    mainButton.disabled = true;
    mainButton.textContent = mainButton.getAttribute('data-adding-text') || 'Adding\u2026';

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (err) { throw err; });
        return response.json();
      })
      .then(function (data) {
        if (window.valtivaShowConfirmPanel) {
          window.valtivaShowConfirmPanel(data);
        }
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = (err && err.description) || 'Something went wrong adding these items to your cart. Please try again.';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        mainButton.disabled = false;
        mainButton.textContent = originalText;
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      if (event.target !== mainForm) return;

      updateButtonState();
      if (getMissingRequiredGroups().length > 0 || isBedSizeMissing()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        errorEl.textContent = 'Please complete all required selections above before adding to cart.';
        errorEl.hidden = false;
        return;
      }

      var selections = getSelections();

      if (selections.missingDateField) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (errorEl) {
          var input = selections.missingDateField.querySelector('[data-addon-date-input]');
          var label = input ? input.getAttribute('data-property-name') : null;
          errorEl.textContent = label
            ? 'Please fill in “' + label + '” before adding to cart.'
            : 'Please fill in the required field above before adding to cart.';
          errorEl.hidden = false;
          selections.missingDateField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (input) input.focus();
        }
        return;
      }

      document.querySelectorAll('[data-addon-date-field]:not([hidden])').forEach(function (field) {
        var input = field.querySelector('[data-addon-date-input]');
        if (input && input.value) {
          selections.properties[input.getAttribute('data-property-name')] = input.value;
        }
      });

      if (selections.missingRequired.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (errorEl) {
          errorEl.textContent = 'Please make a real selection for all required options above before adding to cart.';
          errorEl.hidden = false;
          selections.missingRequired[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var idInput = mainForm.querySelector('[name="id"]');
      var qtyInput = null;
      if (mainForm.elements && mainForm.elements.namedItem) {
        qtyInput = mainForm.elements.namedItem('quantity');
        if (qtyInput && !qtyInput.tagName && qtyInput.length) qtyInput = qtyInput[0];
      }
      if (!qtyInput) qtyInput = mainForm.querySelector('[name="quantity"]');
      var mainVariantId = idInput ? idInput.value : null;
      var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
      if (!(quantity >= 1)) quantity = 1;

      if (!mainVariantId) return;

      /* T8-003A: a page with no add-on groups (the mattress template) has no bed
         configuration to protect, so skip the bed-specific duplicate modal and add normally. */
      if (addonGroups.length === 0) {
        performAddToCart(selections, mainVariantId, quantity);
        return;
      }

      /* Check for an existing matching bed before doing anything else. Only
         products with a real cart-add flow through this file need this -
         it runs for every product page, which is correct, since the same
         duplicate-bed problem can happen with or without add-ons. */
      window.valtivaFindExistingBed(mainVariantId).then(function (existing) {
        if (!existing) {
          performAddToCart(selections, mainVariantId, quantity);
          return;
        }

        window.valtivaShowDuplicateModal().then(function (choice) {
          if (choice === 'cancel') return;

          if (choice === 'update') {
            window.valtivaRemoveExistingBundle(existing).then(function () {
              performAddToCart(selections, mainVariantId, quantity);
            });
            return;
          }

          performAddToCart(selections, mainVariantId, quantity);
        });
      });
    },
    true
  );
});